import api from "./api"

export const fnGetNorms = async () => {
    const response = api.get(`/operational-panel-boards-norms`)
    return response
}

export const fnGetNormsRequisits = async () => {
    const response = api.get("op-panel/boards/requisites")
    return response
}

export const fnGetNormsRequisites = async () => {
    const response = api.get("document/norms-requisites")
    return response
}